import { DocumentStatus as DocumentStatusPB } from '@/gen/artifacts/v1/model_pb'

// We don't use the DocumentStatusPB enum because it includes ANALYZING, which is not a valid DocumentStatus
// It's only used for backward compatibility with existing past assessments
export enum DocumentStatus {
  UNSPECIFIED = DocumentStatusPB.UNSPECIFIED,
  PENDING = DocumentStatusPB.PENDING,
  CLASSIFYING = DocumentStatusPB.CLASSIFYING,
  COMPLETE = DocumentStatusPB.COMPLETE,
}

export const toDocumentStatus = (status: DocumentStatusPB | undefined): DocumentStatus => {
  switch (status) {
    case DocumentStatusPB.PENDING:
      return DocumentStatus.PENDING
    case DocumentStatusPB.CLASSIFYING:
      return DocumentStatus.CLASSIFYING
    case DocumentStatusPB.COMPLETE:
    case DocumentStatusPB.ANALYZING:
      return DocumentStatus.COMPLETE
    default:
      return DocumentStatus.UNSPECIFIED
  }
}
